import * as React from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import AutoFixHighRoundedIcon from '@mui/icons-material/AutoFixHighRounded';
import ConstructionRoundedIcon from '@mui/icons-material/ConstructionRounded';
import QueryStatsRoundedIcon from '@mui/icons-material/QueryStatsRounded';
import SettingsSuggestRoundedIcon from '@mui/icons-material/SettingsSuggestRounded';
import SupportAgentRoundedIcon from '@mui/icons-material/SupportAgentRounded';
import ThumbUpAltRoundedIcon from '@mui/icons-material/ThumbUpAltRounded';

const items = [
  {
    icon: <SettingsSuggestRoundedIcon />,
    title: 'Personalized Service',
    description:
      'We treat every family like our own, customizing each project to fit your unique needs and dreams.',
  },
  {
    icon: <ConstructionRoundedIcon />,
    title: 'Quality Workmanship',
    description:
      'Our family team takes pride in building safe, lasting homes with attention to every detail.',
  },
  {
    icon: <ThumbUpAltRoundedIcon />,
    title: 'Family Satisfaction',
    description:
      'We value open communication and honesty, making your building experience comfortable and worry-free.',
  },
  {
    icon: <AutoFixHighRoundedIcon />,
    title: 'Modern Solutions',
    description:
      'We blend traditional values with the latest building techniques to create homes for today’s families.',
  },
  {
    icon: <SupportAgentRoundedIcon />,
    title: 'Caring Support',
    description:
      'From start to finish, our family is here to answer your questions and guide you every step of the way.',
  },
  {
    icon: <QueryStatsRoundedIcon />,
    title: 'Meticulous Attention',
    description:
      'We focus on the little things, ensuring your family’s home is built with care from foundation to finish.',
  },
];

export default function Highlights() {
  return (
    <Box
      id="highlights"
      sx={{
        pt: { xs: 4, sm: 12 },
        pb: { xs: 8, sm: 16 },
        color: 'white',
        bgcolor: 'grey.900',
      }}
    >
      <Container
        sx={{
          position: 'relative',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: { xs: 3, sm: 6 },
        }}
      >
        <Box
          sx={{
            width: { sm: '100%', md: '60%' },
            textAlign: { sm: 'left', md: 'center' },
          }}
        >
          <Typography component="h2" variant="h4" gutterBottom>
            Highlights
          </Typography>
            <Typography variant="body1" sx={{ color: 'grey.400' }}>
              Whether it’s a renovation, addition, or a small custom project, our family company is dedicated to making your vision a reality. We bring personal care, quality workmanship, and clear communication to every job—no matter the size.
            </Typography>
        </Box>
        <Grid container spacing={2}>
          {items.map((item, index) => (
            <Grid size={{ xs: 12, sm: 6, md: 4 }} key={index}>
              <Stack
                direction="column"
                component={Card}
                spacing={1}
                useFlexGap
                sx={{
                  color: 'inherit',
                  p: 3,
                  height: '100%',
                  borderColor: 'hsla(220, 25%, 25%, 0.3)',
                  backgroundColor: 'grey.800',
                }}
              >
                <Box sx={{ opacity: '50%' }}>{item.icon}</Box>
                <div>
                  <Typography gutterBottom sx={{ fontWeight: 'medium' }}>
                    {item.title}
                  </Typography>
                  <Typography variant="body2" sx={{ color: 'grey.400' }}>
                    {item.description}
                  </Typography>
                </div>
              </Stack>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}
